import type { VIEW_PAGES } from 'src/managers/viewConfig.store';

/** `purchase-orders-v2` → `Purchase orders`. */
const humanizeViewPage = (page: VIEW_PAGES): string => {
  const words = page.replace(/-v\d+$/, '').replace(/-/g, ' ');

  return words.charAt(0).toUpperCase() + words.slice(1);
};

/** What the grid is a grid OF — the noun its toolbar and its search box are both named after. */
export const gridSubjectLabel = (entityNamePlural?: string, viewPage?: VIEW_PAGES): string =>
  entityNamePlural ?? (viewPage ? humanizeViewPage(viewPage) : 'Grid');

/**
 * Accessible name for a grid toolbar — `role="toolbar"` is only useful once it
 * says WHICH grid it drives, since a page can carry several.
 */
export const gridToolbarLabel = (entityNamePlural?: string, viewPage?: VIEW_PAGES): string =>
  `${gridSubjectLabel(entityNamePlural, viewPage)} toolbar`;
